/* ==========================================================================
   Kenza Pro — Reviews
   Single-track carousel · smart arrow visibility · accessible
   ========================================================================== */
(function () {
  'use strict';

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function $(sel, root)  { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function Reviews(root) {
    this.root      = root;
    this.viewport  = $('.kp-rv__viewport', root);
    this.track     = $('.kp-rv__track', root);
    this.cards     = $$('.kp-rv-card', root);
    this.dots      = $$('.kp-rv-dot', root);
    this.prevBtn   = $('.kp-rv__arrow--prev', root);
    this.nextBtn   = $('.kp-rv__arrow--next', root);
    this.live      = $('.kp-rv__live', root);

    if (!this.track || this.cards.length === 0) return;

    this.autoplay     = root.dataset.autoplay === 'true';
    this.interval     = parseInt(root.dataset.interval, 10) || 7000;
    this.pauseOnHover = root.dataset.pauseOnHover !== 'false';

    this.activeIndex   = 0;
    this.autoplayTimer = null;
    this.isHovering    = false;
    this.isFocusWithin = false;
    this.isDragging    = false;
    this.userTouching  = false;
    this.observer      = null;
    this.inViewport    = false;

    /* Video state: collect all video elements + sound toggle buttons per card.
       soundOn is a section-level user preference (carries across slides). */
    this.videos     = this.cards.map(function (card) { return card.querySelector('[data-kp-video]'); });
    this.soundBtns  = this.cards.map(function (card) { return card.querySelector('[data-kp-sound-toggle]'); });
    this.soundOn    = false;

    this._bind();
    this._bindVideoControls();
    this._reveal();
    this._observe();
    this._updateActive(0, true);
    this._updateArrows();

    if (this.autoplay && !prefersReducedMotion) this._startAutoplay();
  }

  /* ============================================================
     VIDEO CONTROLS — autoplay active slide, mute/unmute toggle,
     pause when out of viewport or when slide changes
     ============================================================ */
  Reviews.prototype._bindVideoControls = function () {
    var self = this;

    /* Sound toggle buttons */
    this.soundBtns.forEach(function (btn, i) {
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        self._toggleSound();
      });
    });

    /* Reflect mute state in the icon when video metadata loads */
    this.videos.forEach(function (video) {
      if (!video) return;
      video.addEventListener('volumechange', function () {
        /* keep button state in sync if some external code unmutes */
        self._syncSoundButtonState();
      });
      /* Ensure muted on init — required for autoplay */
      video.muted = true;
    });
  };

  Reviews.prototype._toggleSound = function () {
    this.soundOn = !this.soundOn;
    var self = this;
    this.videos.forEach(function (video, i) {
      if (!video) return;
      /* Only unmute the currently active slide; others stay muted to save bandwidth */
      var shouldUnmute = self.soundOn && i === self.activeIndex;
      video.muted = !shouldUnmute;
    });
    this._syncSoundButtonState();
  };

  Reviews.prototype._syncSoundButtonState = function () {
    var on = this.soundOn;
    this.soundBtns.forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      btn.setAttribute('aria-label', on ? 'Geluid uitzetten' : 'Geluid aanzetten');
    });
  };

  Reviews.prototype._playActiveVideo = function () {
    if (!this.inViewport) return;
    var self = this;
    this.videos.forEach(function (video, i) {
      if (!video) return;
      if (i === self.activeIndex) {
        /* Unmute if user has sound enabled, otherwise keep muted */
        video.muted = !self.soundOn;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          /* Suppress unhandled promise rejection if autoplay blocked */
          p.catch(function () { /* noop */ });
        }
      } else {
        video.pause();
        video.currentTime = 0;
        video.muted = true;
      }
    });
  };

  Reviews.prototype._pauseAllVideos = function () {
    this.videos.forEach(function (video) {
      if (!video) return;
      video.pause();
    });
  };

  Reviews.prototype._bind = function () {
    var self = this;

    this.dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        self._goTo(i);
        self._restartAutoplay(true);
      });
    });

    if (this.prevBtn) this.prevBtn.addEventListener('click', function () {
      self._goTo(self._prevIndex());
      self._restartAutoplay(true);
    });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () {
      self._goTo(self._nextIndex());
      self._restartAutoplay(true);
    });

    var rafId = null;
    this.track.addEventListener('scroll', function () {
      if (rafId) window.cancelAnimationFrame(rafId);
      rafId = window.requestAnimationFrame(function () {
        self._onScroll();
        self._updateArrows();
      });
    }, { passive: true });

    /* desktop drag */
    var isDown = false, startX = 0, startScroll = 0;
    this.track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      isDown = true;
      self.isDragging = false;
      startX = e.pageX;
      startScroll = self.track.scrollLeft;
    });
    this.track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      var dx = e.pageX - startX;
      if (Math.abs(dx) > 5 && !self.isDragging) {
        self.isDragging = true;
        self.track.classList.add('is-dragging');
        self._pauseAutoplay();
      }
      if (self.isDragging) self.track.scrollLeft = startScroll - dx;
    });
    var endDrag = function () {
      if (!isDown) return;
      isDown = false;
      if (self.isDragging) {
        self.isDragging = false;
        self.track.classList.remove('is-dragging');
        self._snapToNearest();
        self._scheduleResumeAutoplay();
      }
    };
    this.track.addEventListener('mouseup', endDrag);
    this.track.addEventListener('mouseleave', endDrag);

    /* touch */
    this.track.addEventListener('touchstart', function () {
      self.userTouching = true;
      self._pauseAutoplay();
    }, { passive: true });
    this.track.addEventListener('touchend', function () {
      self.userTouching = false;
      self._scheduleResumeAutoplay();
    });

    /* hover / focus pause */
    if (this.pauseOnHover) {
      this.root.addEventListener('mouseenter', function () { self.isHovering = true;  self._pauseAutoplay(); });
      this.root.addEventListener('mouseleave', function () { self.isHovering = false; self._scheduleResumeAutoplay(); });
    }
    this.root.addEventListener('focusin',  function () { self.isFocusWithin = true;  self._pauseAutoplay(); });
    this.root.addEventListener('focusout', function () { self.isFocusWithin = false; self._scheduleResumeAutoplay(); });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        self._pauseAutoplay();
        self._pauseAllVideos();
      } else {
        if (self.autoplay) self._scheduleResumeAutoplay();
        self._playActiveVideo();
      }
    });

    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); self._goTo(self._prevIndex()); self._restartAutoplay(true); }
      if (e.key === 'ArrowRight') { e.preventDefault(); self._goTo(self._nextIndex()); self._restartAutoplay(true); }
      if (e.key === 'Home')       { e.preventDefault(); self._goTo(0); }
      if (e.key === 'End')        { e.preventDefault(); self._goTo(self.cards.length - 1); }
    });
  };

  Reviews.prototype._onScroll = function () {
    if (!this.cards.length) return;
    var rect = this.track.getBoundingClientRect();
    var center = rect.left + rect.width / 2;
    var closest = 0, closestDist = Infinity;
    for (var i = 0; i < this.cards.length; i++) {
      var r = this.cards[i].getBoundingClientRect();
      var d = Math.abs(r.left + r.width / 2 - center);
      if (d < closestDist) { closestDist = d; closest = i; }
    }
    if (closest !== this.activeIndex) this._updateActive(closest, false);
  };

  Reviews.prototype._updateActive = function (idx, silent) {
    this.activeIndex = idx;
    this.cards.forEach(function (c, i) { c.classList.toggle('is-active', i === idx); });
    this.dots.forEach(function (d, i) {
      d.classList.toggle('is-active', i === idx);
      if (i === idx) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
    if (!silent && this.live) {
      this.live.textContent = 'Review ' + (idx + 1) + ' van ' + this.cards.length;
    }
    /* Video: play active, pause+reset others */
    this._playActiveVideo();
  };

  Reviews.prototype._updateArrows = function () {
    if (!this.prevBtn || !this.nextBtn) return;
    var sl = this.track.scrollLeft;
    var sw = this.track.scrollWidth;
    var cw = this.track.clientWidth;
    var atStart = sl <= 4;
    var atEnd   = sl + cw >= sw - 4;
    this.prevBtn.hidden = atStart;
    this.nextBtn.hidden = atEnd;
  };

  Reviews.prototype._nextIndex = function () { return (this.activeIndex + 1) % this.cards.length; };
  Reviews.prototype._prevIndex = function () { return (this.activeIndex - 1 + this.cards.length) % this.cards.length; };

  Reviews.prototype._goTo = function (idx) {
    if (idx < 0 || idx >= this.cards.length) return;
    var card = this.cards[idx];
    var left = card.offsetLeft - this.track.offsetLeft;
    try {
      this.track.scrollTo({ left: left, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    } catch (e) {
      this.track.scrollLeft = left;
    }
    this._updateActive(idx, false);
  };

  Reviews.prototype._snapToNearest = function () { this._goTo(this.activeIndex); };

  /* AUTOPLAY */
  Reviews.prototype._startAutoplay = function () {
    if (!this.autoplay || prefersReducedMotion) return;
    if (this.isHovering || this.isFocusWithin || this.userTouching || !this.inViewport) return;
    var self = this;
    this._pauseAutoplay();
    this.autoplayTimer = window.setTimeout(function () {
      self._goTo(self._nextIndex());
      self._startAutoplay();
    }, this.interval);
  };

  Reviews.prototype._pauseAutoplay = function () {
    if (this.autoplayTimer) {
      window.clearTimeout(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  };

  Reviews.prototype._scheduleResumeAutoplay = function () {
    if (!this.autoplay || prefersReducedMotion) return;
    var self = this;
    window.setTimeout(function () {
      if (!self.isHovering && !self.isFocusWithin && !self.userTouching && self.inViewport) {
        self._startAutoplay();
      }
    }, 2000);
  };

  Reviews.prototype._restartAutoplay = function (afterUserAction) {
    this._pauseAutoplay();
    if (!this.autoplay || prefersReducedMotion) return;
    var self = this;
    var delay = afterUserAction ? 5000 : this.interval;
    window.setTimeout(function () {
      if (!self.isHovering && !self.isFocusWithin && !self.userTouching && self.inViewport) {
        self._startAutoplay();
      }
    }, delay);
  };

  /* OBSERVERS */
  Reviews.prototype._observe = function () {
    if (typeof IntersectionObserver === 'undefined') {
      this.inViewport = true;
      return;
    }
    var self = this;
    this.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        self.inViewport = e.isIntersecting;
        if (e.isIntersecting) {
          if (self.autoplay) self._scheduleResumeAutoplay();
          self._playActiveVideo();
        } else {
          self._pauseAutoplay();
          self._pauseAllVideos();
        }
      });
    }, { threshold: 0.2 });
    this.observer.observe(this.root);
  };

  Reviews.prototype._reveal = function () {
    if (typeof IntersectionObserver === 'undefined' || prefersReducedMotion) {
      this.root.classList.add('is-revealed');
      return;
    }
    var self = this;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          self.root.classList.add('is-revealed');
          obs.disconnect();
        }
      });
    }, { threshold: 0.15 });
    obs.observe(this.root);
  };

  Reviews.prototype.destroy = function () {
    this._pauseAutoplay();
    this._pauseAllVideos();
    if (this.observer) this.observer.disconnect();
  };

  /* INIT */
  var instances = new WeakMap();

  function initAll(scope) {
    $$('.kp-rv', scope || document).forEach(function (el) {
      if (!instances.has(el)) instances.set(el, new Reviews(el));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    $$('.kp-rv', e.target).forEach(function (el) {
      var inst = instances.get(el);
      if (inst) {
        inst.destroy();
        instances.delete(el);
      }
    });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var carousel = e.target.closest('.kp-rv');
    if (!carousel) return;
    var inst = instances.get(carousel);
    if (!inst) return;
    var card = e.target.closest('.kp-rv-card');
    if (!card) return;
    var idx = inst.cards.indexOf(card);
    if (idx >= 0) inst._goTo(idx);
  });

  var resizeRAF = null;
  window.addEventListener('resize', function () {
    if (resizeRAF) window.cancelAnimationFrame(resizeRAF);
    resizeRAF = window.requestAnimationFrame(function () {
      $$('.kp-rv').forEach(function (el) {
        var inst = instances.get(el);
        if (inst) inst._updateArrows();
      });
    });
  });
})();